import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../Spinner/Spinner";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { loadWeb3 } from "../../WalletConectivity/walletConnection";
import { Abi_USDT, ContractAddress_USDT } from "../../abi";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function RequestToken() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [Uid, setUid] = useState(null);
  const [uplineId, setuplineId] = useState(null);
  const [fdate, setfdate] = useState("");

  const [dataOutput, setdataOutput] = useState([]);
  const [account, setAccount] = useState("");
  const [Rank, setRank] = useState(0);

  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait..."
  );
  const [spinner, setSpinner] = useState(false);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/PendingRewardHistory",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          fdate: fdate,
          RankId: Rank,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("My_Team", responceRight?.data?.dataOut?.TotalUsd);

      setdataOutput(responceRight?.data?.dataOut?.TotalUsd);
      console.log("My_Team", responceRight?.data);
      responceRight = responceRight.data.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          uid: item.uid,
          id: item?.id,
          userid: ` ${item.uid}`,
          address: item.wallet,
          row: `  ${item.row} `,
          amountusd: item.Req_matching,
          requestAmount: item.reward,
          widthralAmount: ` ${item.reward}`,
          date: ` ${item.rdate}`,
          remark: ` ${item.rank_name}`,
          txn: ` ${item.txn}`,
          PaidContract: (
            <>
              <button
                className="btn btn-info btn-lg"
                style={{
                  width: "70px",
                  borderRadius: "13px",
                }}
                onClick={() =>
                  PayReward(item.id, item.reward, item.uid, item.wallet, 1)
                }>
                Pay
              </button>
            </>
          ),
          PaidManual: (
            <>
              <button
                className="btn btn-info btn-lg"
                style={{
                  width: "70px",
                  borderRadius: "13px",
                }}
                onClick={() =>
                  PayReward(item.id, item.reward, item.uid, item.wallet, 2)
                }>
                Pay
              </button>
            </>
          ),
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PendingRewardHistory",
        {
          loginid: userId,
          uid: Uid || 0,
          uplineid: uplineId || 0,
          fdate: fdate,
          RankId: Rank,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight.data.data[0];

      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: ` ${item.uid}`,
          Address: item.wallet,
          MatchingBusiness: item.Req_matching,
          RewardAmount: item.reward,
          Date: ` ${item.rdate}`,
          RankName: ` ${item.rank_name}`,
        });
      });

      const fileName = "PendingReward";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const bnbWalletConnection = async () => {
    try {
      let acc = await loadWeb3();
      setAccount(acc);
      if (acc == "No Wallet") {
        toast.error("No Wallet");
        setconnected("Wallet is locked");
      } else if (acc == "Wrong Network") {
        toast.error(" Wrong Network Please Connect Metamask Network");
        setconnected("Wallet is locked");
      } else {
        // setaddress(acc)
        console.log("Metamask Address", acc);
        setconnected("Wallet is Connected");
      }
    } catch (e) {
      console.log("Error While WalletConnect", e);
    }
  };

  const PayReward = async (RowId, Amount, UserId, WalletAddress, type) => {
    try {
      setSpinner(true);
      if (type === 1) {
        // let responce = await API.post("/CheckBnbaddress", {
        //   Address: address,
        // });

        // console.log("Result", responce.data);

        // if (responce.data.data.result == "Your address is not bnb Address") {
        //   toast.error("Wrong Bnb Address...!!");
        //   Window.location.reload();
        //   return;
        // }

        if (WalletAddress == null) {
          toast.error("Wrong Wallet Address !!!");
          return;
        }

        bnbWalletConnection();

        let acc = await loadWeb3();
        if (acc === "No Wallet") {
          toast.error("No Wallet");
        } else if (acc === "Wrong Network") {
          toast.error("Wrong Network Please Connect Metamask Network");
        } else {
          // const gasPrice = await window.web3.eth.getGasPrice();

          let contract = await new window.web3.eth.Contract(
            Abi_USDT,
            ContractAddress_USDT
          );
          const amountvalue = Amount.toString();
          let WithdawlAmount = window.web3.utils.toWei(amountvalue);
          let trxResult = await contract.methods
            .transfer(WalletAddress, WithdawlAmount.toString())
            .send({
              from: acc,
              // ,gasPrice: gasPrice,
            });
          console.log("trxResult", trxResult);
          trxResult = trxResult.transactionHash;
          if (
            trxResult !== "" ||
            trxResult !== undefined ||
            trxResult !== null
          ) {
            let res = await API.post(
              "/PaidReward",
              {
                loginid: userId,
                uid: UserId,
                id: RowId,
                txn: trxResult,
                type: 2,
              },
              {
                headers: {
                  Authorization: jwt_token,
                },
              }
            );
            toast.success(res.data.data.result);
            window.location.reload();
          }
        }
      } else {
        let res = await API.post(
          "/PaidReward",
          {
            loginid: userId,
            uid: UserId,
            id: RowId,
            txn: "Manually Paid",
            type: 2,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        console.log("approve_api", res.data.data);
        toast.success(res.data.data.result);
        window.location.reload();
      }
    } catch (error) {
      console.log("API ERROR", error);
      setSpinner(false);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Wallet Address", accessor: "address" },
      { Header: "Rank Name", accessor: "remark" },
      { Header: "Matching Business", accessor: "amountusd" },
      { Header: "Reward Amount (USDT)", accessor: "requestAmount" },
      { Header: "Requested Date", accessor: "date" },
      { Header: "Manual Paid", accessor: "PaidManual" },
      { Header: "Contract Paid", accessor: "PaidContract" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Pending Reward</h4>
                </div>
                <div class="panel-body">
                  <div class="row mb-2">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <select
                        name="Position"
                        className="form-control"
                        onChange={(e) => setRank(e.target.value)}>
                        <option>Select Rank</option>
                        <option value="1">Basic</option>
                        <option value="2">1 STAR</option>
                        <option value="3">2 STAR</option>
                        <option value="4">3 STAR</option>
                        <option value="5">4 STAR</option>
                        <option value="6">5 STAR</option>
                        <option value="7">6 STAR</option>
                        <option value="8">7 STAR</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Upline Id"
                        maxLength={6}
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div class="row mb-2 ">
                    <div class="col-md-4 text-center">
                      <input
                        type="reset"
                        onClick={() => bnbWalletConnection()}
                        class="btn btn-md btn-success"
                        value="Connect Wallet"
                      />
                    </div>
                    <div class="col-md-8">
                      <span> Connected Wallet : {account}</span>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div>
                      <b>Reward Total: {dataOutput}</b>
                    </div>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestToken;
